// Site menu, shared by the desktop menu, mobile menu, and footer.
export const sections = [
  {
    title: "Surgical Care Optimization",
    links: [
      { label: "Surgical Cost Management", to: "/caremeasurement/" },
      {
        label: "Surgical Coding Optimization",
        to: "/surgical-coding-optimization/",
      },
      { label: "Surgical Quality and Outcomes Optimization", to: "/eras/" },
      { label: "PACU and OR Throughput", to: "/pacu-and-or-throughput/" },
    ],
  },
  {
    title: "Bundled Payments",
    links: [
      {
        label: "Bundled Payments Overview",
        footerLabel: "Overview",
        to: "/bundled-payments/",
      },
      { label: "CJR-X", to: "/bundled-payments/cjr-x/" },
      { label: "CMS TEAM", to: "/cms-team/" },
    ],
  },
  {
    title: "Case Studies",
    links: [
      {
        label: "Mass General Brigham - Newton Wellesley",
        to: "/mgb-newton-wellesley-hospital-case-study/",
      },
      {
        label: "Penn State - Hershey Medical",
        to: "/hershey-medical-center-case-study/",
      },
      {
        label: "Rothman Orthopedics",
        to: "/rothman-orthopedics-and-nuehealth-save-1.7-million-with-avant-garde/",
      },
    ],
  },
  {
    title: "Research",
    links: [
      {
        label: "Healthcare Research All-Stars",
        to: "/best-surgeons-and-hospitals-research-all-stars/",
      },
      { label: "Research and Publications", to: "/publications/" },
      { label: "VBHC Research Group", to: "/vbhc-research-group/" },
    ],
  },
  {
    title: "Our Company",
    links: [
      { label: "About Us", to: "/about-us/" },
      { label: "News", to: "/news/" },
      { label: "Blog", to: "/blog/" },
      { label: "Our Team", to: "/our-team/" },
      { label: "Careers", to: "/careers/" },
      { label: "Privacy Policy", to: "/privacy-policy/" },
      { label: "Trust Center", href: "https://trust.avantgardehealth.com/" },
    ],
  },
]

export const summit = {
  label: "2026 Summit",
  href: "https://summit.avantgardehealth.com",
}

export const login = { label: "Login", href: "https://caremeasurement.com" }

export const social = [
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/avant-garde-health",
  },
  { label: "Twitter", href: "https://twitter.com/avantgarde" },
]

// The desktop header tightens in two steps so the full menu fits down to the
// mobile breakpoint, where it swaps to the mobile menu.
export const medium = "@media (max-width: 1320px)"
export const compact = "@media (max-width: 1200px)"
export const mobileQuery = "(max-width: 1100px)"
export const mobile = `@media ${mobileQuery}`
